// Aviso previo a «Cambiar por el kit» (REQ-78): qué cambia en equipo, tope, regalo y código.
import { Button } from '@/kit';
import { formatMXN } from '@/shared/lib/format/money';
import type { KitSwapCapChange } from '../buildSale';
import type { KitSwapOption } from './BuildSaleEquipment';

export function KitSwapNotice({
    kit,
    giftNames,
    discountCode,
    capChange,
    creditCapCents,
    busy,
    onConfirm,
    onCancel,
}: {
    kit: KitSwapOption;
    giftNames: string[];
    discountCode?: string;
    /** Tope de extras de hoy contra el del kit; sin reparto no se menciona. */
    capChange?: KitSwapCapChange;
    /** Tope del nivel del cliente (servidor); sin nivel no se menciona. */
    creditCapCents?: number;
    busy: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}) {
    const changes = [`El equipo pasa a ${kit.name} por ${formatMXN(kit.priceCents / 100)}.`];
    if (kit.financeable === false) {
        changes.push('SureKeep no financia el kit: todo va de contado.');
    } else if (capChange !== undefined) {
        const cap = `El tope de extras a crédito pasa de ${formatMXN(capChange.fromCents / 100)} a ${formatMXN(capChange.toCents / 100)}`;
        changes.push(
            capChange.toCashCents > 0
                ? `${cap}; ${formatMXN(capChange.toCashCents / 100)} de los extras pasa a contado.`
                : `${cap}.`,
        );
    }
    if (creditCapCents !== undefined) {
        const cap = `El tope de crédito del cliente es ${formatMXN(creditCapCents / 100)}`;
        changes.push(
            kit.affordableOnCredit === false
                ? `${cap}; el kit no alcanza y solo va de contado.`
                : `${cap}.`,
        );
    }
    if (giftNames.length > 0) {
        changes.push(
            `Se quita el regalo (${giftNames.join(', ')}). Si el kit trae promo, se vuelve a ofrecer.`,
        );
    }
    if (discountCode !== undefined) {
        changes.push(`El código ${discountCode} pasa al kit y se vuelve a validar.`);
    }

    return (
        <div
            role="alert"
            className="flex flex-col gap-2 rounded-md border border-warning-soft-border bg-warning-soft px-3 py-2.5 text-[12.5px]"
        >
            <b>Antes de cambiar por el kit</b>
            <ul className="list-disc pl-5">
                {changes.map((c) => (
                    <li key={c}>{c}</li>
                ))}
            </ul>
            <div className="flex flex-wrap gap-2">
                <Button size="sm" isLoading={busy} onClick={onConfirm}>
                    Cambiar por el kit
                </Button>
                <Button size="sm" variant="outline" disabled={busy} onClick={onCancel}>
                    Mejor no
                </Button>
            </div>
        </div>
    );
}
